<template>
    <v-container fluid >
      <v-dialog
       v-model="dialogVisible"
        persistent
      >
        <div class="ma-3" >
        <v-card >
          <div id="cropimagecontainer" ref="cropimagecontainer" >
            <img ref="cropimage" id="cropimage" style="max-width: 100%" src="imgSrc">
            </div>
          <v-card-actions>
            <v-btn
              left
              color="primary"
              flat
              v-on:click="cancelCrop()">
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              flat
              v-on:click="commitCrop()">
              Crop
            </v-btn>

          </v-card-actions>
        </v-card>
        </div>
      </v-dialog>
    </v-container>
</template>

<script>
import Cropper from 'cropperjs'
require('cropperjs/dist/cropper.js')
require('cropperjs/dist/cropper.css')

export default {
  data () {
    return {
      dialogVisible: false,
      imgSrc: '',
      cropper: null
    }
  },
  computed: {
  },
  methods: {
    commitCrop () {
      this.$emit('crop', this.cropper.getData())
      this.dialogVisible = false
    },
    cancelCrop () {
      this.dialogVisible = false
    },
    setImage (data) {
      if (data) {
        this.imgSrc = data
        var imgelement = this.$refs['cropimage']
        if (!imgelement) {
          console.error('no image element')
          return
        }
        imgelement.src = data
        var options = {
          autoCropArea: 1.0,
          background: false,
          viewMode: 1 // restrict the crop box to not exceed the size of the canvas.
        }
        if (!this.cropper) {
          this.cropper = new Cropper(imgelement, options)
        }
        this.dialogVisible = true
      }
    }
  },
  created: function () {

  },
  mounted: function () {

  }
}

</script>



// WEBPACK FOOTER //
// src/components/CharacterPicker/ImageCrop.vue